"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _react = _interopRequireDefault(require("react"));
var _withTheme = _interopRequireDefault(require("./withTheme"));
var _jsxRuntime = require("react/jsx-runtime");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { default: e }; }
const Icon = props => /*#__PURE__*/(0, _jsxRuntime.jsxs)("g", {
  transform: "translate(12.035190, 12.035190) rotate(-45.000000) translate(-12.035190, -12.035190) translate(2.035190, 7.489735)",
  stroke: "currentColor",
  strokeWidth: "2",
  fill: "none",
  fillRule: "evenodd",
  strokeLinecap: "round",
  strokeLinejoin: "round",
  children: [/*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M12.7272727,0 L15.4545455,0 C16.660075,1.61486985e-15 17.8162291,0.478894729 18.6686672,1.33133281 C19.5211053,2.1837709 20,3.33992505 20,4.54545455 C20,7.05583977 17.9649307,9.09090909 15.4545455,9.09090909 L12.7272727,9.09090909 M7.27272727,9.09090909 L4.54545455,9.09090909 C3.33992505,9.09090909 2.1837709,8.61201436 1.33133281,7.75957628 C0.478894729,6.90713819 1.00929366e-16,5.75098404 0,4.54545455 C-2.01858732e-16,2.03506932 2.03506932,1.77635684e-15 4.54545455,1.77635684e-15 L7.27272727,1.77635684e-15"
  }), /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
    d: "M6.36363636,4.54545455 L13.6363636,4.54545455"
  })]
});
var _default = exports.default = (0, _withTheme.default)(Icon);